import type { ApiClientOptions } from "./client";
import { createApiClient } from "./client";

export type FeedbackType = "bug" | "feature";
export type FeedbackStatus = "pending" | "reviewed" | "rewarded";

export interface FeedbackSubmission {
  type: FeedbackType;
  title: string;
  description: string;
}

export interface FeedbackItem {
  id: string;
  user_id: string;
  type: FeedbackType;
  title: string;
  description: string;
  status: FeedbackStatus;
  credits_awarded: number;
  created_at: string;
  updated_at: string;
}

export function createFeedbackApi(options: ApiClientOptions) {
  const api = createApiClient(options);

  return {
    submit: (data: FeedbackSubmission) =>
      api.post<FeedbackItem>("/api/feedback", data),
  };
}
